export default __webpack_public_path__ + "static/media/ideate.0b6c50d8.svg";